import React from "react";

/**
 * Props:
 * - speaker: "Pan" | "Wis" | "Zeb" | string
 * - avatarSrc: optional image path (prefer /images/... from public)
 * - children: dialogue text (string or nodes)
 * - tone: "success" | "info" | "warning" | "default"
 */
export default function DialogueBox({
  speaker = "Pan",
  avatarSrc,
  tone = "default",
  children,
}) {
  const toneStyles = {
    success: "border-green-300 bg-green-50",
    info: "border-blue-300 bg-blue-50",
    warning: "border-amber-300 bg-amber-50",
    default: "border-slate-300 bg-white",
  }[tone];

  // Ensure public URL (leading slash) and provide a fallback image
  const ensurePublic = (p) => {
    if (!p) return "";
    if (p.startsWith("http")) return p;
    return p.startsWith("/") ? p : `/${p}`;
  };
  const src = ensurePublic(avatarSrc || "/images/pan-the-panda.png");

  return (
    <div
      className={`w-full rounded-2xl border ${toneStyles} shadow-md p-4 md:p-6 flex gap-3 items-start`}
    >
      <div className="flex-shrink-0">
        {avatarSrc ? (
          <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-white border border-slate-200 shadow grid place-items-center overflow-hidden">
            <img
              src={src}
              alt={speaker}
              loading="lazy"
              className="w-full h-full object-contain p-1" /* show full PNG inside circle */
              onError={(e) => {
                e.currentTarget.src = "/images/pan-the-panda.png";
              }}
            />
          </div>
        ) : (
          <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-slate-200 grid place-items-center text-slate-600 font-bold">
            {speaker?.[0] || "?"}
          </div>
        )}
      </div>

      <div className="flex-1">
        <div className="font-semibold text-slate-700 mb-1">{speaker}</div>
        <div className="text-slate-700 leading-relaxed">{children}</div>
      </div>
    </div>
  );
}
